import React from "react";

import {
  Col,
  Row,
  Breadcrumb,
  BreadcrumbItem,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const Header = ({ onSearchSeeds }) => {
  return (
    <Row className="mb-2 mb-xl-4">
      <Col xs="auto">
        <Breadcrumb>
          <BreadcrumbItem>
            {/* <Link to="/dashboards">Dashboards</Link> */}
            Admin
          </BreadcrumbItem>

          <BreadcrumbItem active>Seed Lists</BreadcrumbItem>
        </Breadcrumb>
      </Col>

      <Col xs="auto" className="ml-auto text-right mt-n1">
        <InputGroup className="mb-3">
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <FontAwesomeIcon icon={faSearch} className="mr-2" />
              Search Seed Lists
            </InputGroupText>
          </InputGroupAddon>

          <Input placeholder="Sample List" name="searchSeeds" onChange={onSearchSeeds} />
        </InputGroup>
      </Col>
    </Row>
  );
};

export default Header;
